import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.less']
})
export class DeleteDialogComponent  {
    // Use remove for variables, but delete for cards since we're not actually deleting the variable/column
    get removalText(): string {
        return this.data.type === 'column_card' ? 'remove' : 'delete';
    }

    constructor(
        public dialogRef: MatDialogRef<DeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string,
            type?: string,
        }
    ) { }
}
